import React from 'react';
import { Link } from 'react-router-dom';
import HeroIm1 from '../../images/2.37dccbecdc50bd3c0abd.webp';
import { TrendingUp, Handshake, Building2, ArrowUpCircle } from 'lucide-react'

const ClickHandler = () => {
    window.scrollTo(10, 0);
}

const Hero2 = () => {
    return (
        <section className="hero_section_s2">
            <div className="container">
                <div className="wrapper">
                    <div className="content">
                        <h2>Maximize Your Pharmacy's Value</h2>
                        <Link onClick={ClickHandler} to="/contact-us" className="theme-btn-s2">Schedule Consultation <i
                            className="flaticon-right-arrow"></i></Link>
                    </div>
                    <div className="image">
                        <img src={HeroIm1} alt="" />
                        <div className="shape">
                            <svg viewBox="0 0 686 686" fill="none">
                                <circle cx="343" cy="343" r="226.5" stroke="#A1BCC0" />
                                <circle cx="343" cy="343" r="278.5" stroke="#A1BCC0" />
                                <circle cx="343" cy="343" r="342.5" stroke="#A1BCC0" />
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
            <div className="important">
                <div className="row g-0">
                    <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                        <div className="item">
                            <div className="icon">
                                <TrendingUp size={50} className="w-8 h-8 text-white" />
                            </div>
                            <h3>Maximize Value</h3>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                        <div className="item">
                            <div className="icon">
                                <Handshake size={50} className="w-8 h-8 text-white" />
                            </div>
                            <h3>Fair Partnership</h3>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                        <div className="item">
                            <div className="icon">
                                <Building2 size={50} className="w-8 h-8 text-white" />
                            </div>
                            <h3>Retain Legacy</h3>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                        <div className="item">
                            <div className="icon">
                                <ArrowUpCircle size={50} className="w-8 h-8 text-white" />
                            </div>
                            <h3>Growth Capital</h3>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Hero2;



